import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useRootStore } from 'stores/RootStore'
import { useBrandProfile } from 'hooks/queries/workspaces/useBrandProfile'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { useCreditUsage } from './useCreditUsage'

export const useNeedsCreditsForCost = (creditCost: number) => {
  const workspace = useCurrentWorkspace()
  const { canAutoReload } = useCreditUsage()
  const {
    creditUsageStore: { creditUsage, initialized: creditUsageInitialized },
    tierUsageStore: { currentSubscription, autopilotAddOns, initialized: tierUsageInitialized },
  } = useRootStore()

  const isOnPioneer = currentSubscription?.plan === PaymentPlanKey.VirtualMarketer
  const isTrialing = currentSubscription?.status === 'trialing'
  const autopilotContentCreditsPrice = autopilotAddOns.find(
    (addon) => addon.key === PaymentPlanKey.BlazeAutopilotContentCredits,
  )?.prices[0]

  const profile = useBrandProfile({ cacheTime: 5 * 60 * 1000 })
  const hasStylizedImage = !!profile?.data?.brand_kit?.content_preferences?.apply_visual_style
  const hasAnimatedImage = !!profile?.data?.brand_kit?.content_preferences?.video_sources?.includes('animated_image')

  const isProcessing = !(profile.isFetched && creditUsageInitialized && tierUsageInitialized)

  const creditsRemaining = creditUsage?.credits_remaining || 0
  const exceedsBalance = creditCost > 0 && creditCost > creditsRemaining
  const pioneerException = isOnPioneer && (isTrialing || (!hasAnimatedImage && !hasStylizedImage))
  const autoReloadCovers =
    !!creditUsage?.can_auto_reload &&
    (workspace?.auto_reload_limit == null || creditCost <= workspace.auto_reload_limit)
  const autoReloadBudgetReached = Boolean(workspace?.auto_reload_credits && !canAutoReload)

  return {
    needsCredits: exceedsBalance && !pioneerException && !autoReloadCovers,
    creditsRemaining,
    autopilotContentCreditsPrice,
    autoReloadBudgetReached,
    isProcessing,
  }
}
